import { intersection } from 'lodash-es';
import { store } from '@/common/root';
import { storeCreator } from '@/common/utils/store.util';
import modules, { grouppedModules } from '@/common/store/modules';
import flatGrouppedMap from '@/common/utils/flatGrouppedMap';
import CommonError from '@/common/utils/errors/CommonError';

const predefinedStoreNames = Object.keys(grouppedModules).concat(Object.keys(modules));

export default function createStore(storeName, storeObj) {
  const namespaces = Array.isArray(storeName) ? storeName : [storeName];

  if (intersection(predefinedStoreNames, namespaces).length) {
    flatGrouppedMap(namespaces, grouppedModules, modules)
      .forEach(module => storeCreator(module, store));

    return;
  }

  if (!storeObj) {
    throw new CommonError('Specify store object');
  }

  if (!store.hasModule(storeName)) {
    store.registerModule(storeName, storeObj);
  }
}

export { createStore };
